import type { KeyboardEvent } from 'react';

const SEARCH_SELECTOR = 'input[data-list-search]';
const ENABLED = ':not(:disabled):not([aria-disabled="true"])';
const ITEM_SELECTOR = `.list-content [data-keyboard-item]${ENABLED}, .list-content input[type="radio"]${ENABLED}`;
const LOAD_MORE_SELECTOR = '.loading-indicator';

const isRadio = (element: HTMLElement) =>
  element instanceof HTMLInputElement && element.type === 'radio';

const requestMoreResults = (root: HTMLElement) =>
  root.querySelector<HTMLElement>(LOAD_MORE_SELECTOR)?.scrollIntoView?.({ block: 'nearest' });

const enterResultsFromSearch = (
  event: KeyboardEvent<HTMLElement>,
  root: HTMLElement,
  search: HTMLElement,
) => {
  const tabsIntoResults = event.key === 'Tab' && search.dataset.tabToResults !== undefined;
  if (event.key !== 'ArrowDown' && !tabsIntoResults) return;
  const firstItem = root.querySelector<HTMLElement>(ITEM_SELECTOR);
  if (!firstItem) return;
  event.preventDefault();
  // office.js in Outlook on the web would move the Tab on from the search field itself.
  if (tabsIntoResults) event.stopPropagation();
  firstItem.focus();
};
export const handleListKeyDown = (event: KeyboardEvent<HTMLElement>) => {
  if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;

  const root = event.currentTarget;
  const target = event.target as HTMLElement;
  const search = root.querySelector<HTMLElement>(SEARCH_SELECTOR);

  if (search && target === search) {
    enterResultsFromSearch(event, root, search);
    return;
  }

  const items = Array.from(root.querySelectorAll<HTMLElement>(ITEM_SELECTOR));
  const index = items.indexOf(target);
  if (index === -1) return;

  if (isRadio(target) && event.key === 'Enter') {
    event.preventDefault();
    target.click();
    return;
  }

  if (isRadio(target) && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
    event.preventDefault();
    return;
  }

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    const next = items[index + 1];
    if (next) next.focus();
    else requestMoreResults(root);
    return;
  }

  if (event.key === 'ArrowUp') {
    event.preventDefault();
    (items[index - 1] ?? search)?.focus();
  }
};
